import { render, staticRenderFns } from "./NewPaymentDocumentPage.vue?vue&type=template&id=39b72967&scoped=true"
import script from "./NewPaymentDocumentPage.vue?vue&type=script&lang=js"
export * from "./NewPaymentDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b72967",
  null
  
)

export default component.exports